
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.767 26.156C55.92 25.461 56 24.74 56 24c0-5.523-4.477-10-10-10-.889 0-1.751.117-2.57.334C41.879 9.5 37.349 6 32 6c-5.459 0-10.066 3.646-11.521 8.636A15.99 15.99 0 0016 14C7.164 14 0 21.164 0 30c0 8.835 7.164 16 16 16h8v12h16V46h14c5.523 0 10-4.477 10-10 0-4.919-3.553-9.01-8.233-9.844zM36 42v12h-8V42H18l14-14 14 14H36z"}})])
          )
        }
      }
    